<template>
  <div
    :class="`tw-flex tw-flex-col tw-w-full tw-max-w-[380px] ${
      isOpen ? 'opened' : ''
    } mainWrapper ${mainWrapperClass}`"
    @click.stop
  >
    <!-- Dropdown button -->
    <div :data-cy="dataCyId" @click="isOpen = !isOpen">
      <slot name="buttonDropdown">
        <div
          :class="`tw-relative tw-h-[56px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-px-[20px] tw-py-[11px] tw-bg-[#F6F7F8] tw-w-full tw-rounded-t-[6px] ${
            isOpen ? '' : 'tw-rounded-b-[6px]'
          } dropdownButton`"
        >
          <span
            class="tw-absolute tw-right-0 tw-rounded-tr-[6px] tw-rounded-br-[6px] blurred"
          />
          <div
            ref="tabletContainer"
            class="tw-max-w-full tw-overflow-x-auto tw-overflow-y-hidden placeholder"
            @wheel="
              (e) => {
                if (!tabletContainer) return;
                tabletContainer.scrollLeft += e.deltaY;
              }
            "
          >
            <div v-if="type === DROPDOWN_TYPE.MULTIPLE">
              <span
                v-if="selectedItems.length <= 0"
                class="tw-text-[#B7B7B7] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
                >{{ placeholder }}</span
              >
              <div
                v-else-if="type === DROPDOWN_TYPE.MULTIPLE"
                class="tw-flex tw-gap-[5px] tw-min-w-[298px] tw-w-full tw-max-w-full lg:tw-max-w-[321px] tw-items-center tabWrapper"
              >
                <TabletView
                  v-for="(item, index) of selectedItems"
                  :key="index"
                  :child-title="item.title"
                  :parent-title="item.parentTitle"
                  @close="
                    () => {
                      handleSelection(item.title, item.parentTitle, item);
                    }
                  "
                  @click.stop
                />
                <!-- Dummy tablet to increase scroll width - contains no data or functions -->
                <TabletView class="tw-invisible" />
              </div>
              <div v-else>
                <span
                  v-if="selectedItems[0].parentTitle"
                  class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal]"
                  >{{ selectedItems[0].parentTitle }}: {{ " " }}</span
                >
                <span
                  class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
                  >{{ selectedItems[0].title }}</span
                >
              </div>
            </div>

            <div v-if="type === DROPDOWN_TYPE.SINGLE">
              <div
                v-if="itemSelected.length <= 0"
                class="tw-text-[#B7B7B7] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
              >
                {{ placeholder }}
              </div>
              <div v-else>
                <span
                  class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
                  >{{ itemSelected[0].name }}</span
                >
              </div>
            </div>
          </div>
          <span :class="`tw-z-[1] arrowIcon ${isOpen ? 'rotated' : ''}`">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="8"
              viewBox="0 0 10 8"
              fill="none"
            >
              <path
                d="M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z"
                fill="#387DFF"
              />
            </svg>
          </span>
        </div>
      </slot>
    </div>
    <!-- Dropdown body -->
    <div
      :class="`dropdownBody tw-flex tw-flex-col tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-bg-white tw-max-h-[240px] !tw-overflow-y-auto ${dropdownClass}`"
    >
      <div
        v-if="enableSearch"
        id="search"
        class="tw-flex tw-items-center tw-gap-[13px] tw-self-stretch tw-px-[26px] tw-py-[12px]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
        >
          <g clip-path="url(#clip0_8996_29950)">
            <path
              d="M8.34729 11.3435C11.2264 10.1199 12.5685 6.79401 11.3449 3.91489C10.1213 1.03576 6.79537 -0.306309 3.91624 0.91729C1.03712 2.14089 -0.304952 5.46681 0.918648 8.34593C2.14225 11.2251 5.46816 12.5671 8.34729 11.3435Z"
              stroke="#B7B7B7"
              stroke-width="0.9375"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.1367 10.1406L14.5298 14.5344"
              stroke="#B7B7B7"
              stroke-width="0.9375"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_8996_29950">
              <rect width="15" height="15" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <input
          type="text"
          class="tw-border-none tw-w-full searchInput"
          :placeholder="searchPlaceholder"
          @input="(e: any) => handleSearch(e?.target?.value)"
        />
      </div>
      <MutliLevelMutliSelectDropdownItem
        v-for="(item, index) of dataShown"
        :key="index"
        :title="item.title"
        :item-description="showDescription ? item.templateDescription : ''"
        :child-data="item.childData"
        :selected="isTitleSelected(item.title)"
        :selected-items="selectedItems"
        data-cy="mutliLevelMutliSelectDropdownItemLevel-1"
        :type="type"
        :search-value="searchValue"
        :is-toggle="item.isToggle"
        @update:selected="
          () => {
            handleSelection(item.title, undefined, item);
          }
        "
        @update:child-selected="
          (itemChildData) => {
            handleSelection(itemChildData.title, item.title, itemChildData);
          }
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from "vue";
import MutliLevelMutliSelectDropdownItem from "./mutliLevelMutliSelectDropdownItem.vue";
import TabletView from "./tabletView.vue";
import { DROPDOWN_TYPE } from "@/utils/constants";
import { generateSelectedItems, getComponentUiText } from "@/utils/utilities";
import { PropType } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";

const emits = defineEmits([
  "update:selected",
  "update:child-selected",
  "update:modelValue",
  "update:store",
  "update:isDropdownOpen",
]);

const props = defineProps({
  showDescription: {
    type: Boolean,
    required: false,
    default: false,
  },
  placeholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-select-services-1",
    ),
  },
  searchPlaceholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-services-question-placeholder-1",
    ),
  },
  data: {
    type: Object as PropType<IMultiSelectDropdown[]>,
    required: false,
    default: () => [] as IMultiSelectDropdown[],
  },
  type: {
    type: String,
    required: false,
    default: DROPDOWN_TYPE.MULTIPLE,
  },
  enableSearch: {
    type: Boolean,
    required: false,
    default: true,
  },
  modelValue: {
    type: String,
    required: false,
    default: "",
  },
  timeUpdated: {
    type: String,
    required: false,
    default: "false",
  },
  dropdownClass: {
    type: String,
    required: false,
    default: "",
  },
  mainWrapperClass: {
    type: String,
    required: false,
    default: "",
  },
  dataCyId: {
    type: String,
    required: false,
    default: "",
  },
});

const isOpen = ref(false);
const dataShown: any = ref(props.data);
const searchValue = ref("");
const tabletContainer: any = ref(null);
const propsDataRef = ref(props.data);

const selectedItems = computed(() => {
  return props.type === DROPDOWN_TYPE.MULTIPLE
    ? generateSelectedItems(propsDataRef.value, "")
    : props.data.filter((item: any) => item.id === props.modelValue);
});

const itemSelected = computed(() => {
  let result: any = [];
  // props.data?.forEach(({ childData, ...item }: any) => {
  //   childData?.forEach((child: any) => {
  //     if (child.id === props.modelValue) {
  //       result = [...result, { ...child, ...item }];
  //     }
  //   });
  // });
  props.data?.forEach((item: any) => {
    if (item.id === props.modelValue) {
      result = [{ ...item }];
    }
  });
  return result;
});

watch(
  () => props.data,
  () => {
    dataShown.value = props.data;
  },
);

watch(
  () => isOpen.value,
  () => {
    emits("update:isDropdownOpen", isOpen.value);
  },
);

watch(
  () => props.timeUpdated,
  () => {
    dataShown.value = props.data;
    propsDataRef.value = props.data;
  },
);

watch(
  () => props.modelValue,
  () => {
    emits("update:selected", itemSelected);
  },
);

const isTitleSelected = (title: string) => {
  return selectedItems.value.some((item: any) => item.title === title);
};

const updateSelectItem = (
  dropdownData: IMultiSelectDropdown[],
  title: string,
) => {
  const updateSelected = (items: IMultiSelectDropdown[], title: string) => {
    for (let item of items) {
      if (item.title === title) item.selected = !item.selected;
      if (item.childData) updateSelected(item.childData, title);
    }

    return items;
  };

  return updateSelected(JSON.parse(JSON.stringify(dropdownData)), title);
};

const handleSelection = (title: string, parentTitle?: string, item?: any) => {
  let temp: IMultiSelectDropdown[] = [...propsDataRef.value];

  dataShown.value = propsDataRef.value = updateSelectItem(temp, title);
  const selectedItems = generateSelectedItems(propsDataRef.value, "");
  const data: IMultiSelectDropdown[] = selectedItems.map((e) => {
    return {
      ...e,
      name: e.parentTitle ? e.parentTitle + e.title : e.title,
      serviceTitle: e.title,
      serviceParentTitle: e.parentTitle || "",
      serviceTypeId: e.id || "",
    } as IMultiSelectDropdown;
  });

  // handle hide after single selected
  if (props.type === DROPDOWN_TYPE.SINGLE) isOpen.value = false;
  let id = null;
  if (itemSelected.value[0]?.id === item.id) {
    id = null;
  } else {
    id = item.id;
  }

  emits("update:modelValue", id || null, data);
  emits("update:store");
};

const handleSearch = (value: string) => {
  searchValue.value = value;
  dataShown.value = props.data.filter((item: any) => {
    return (
      item.title.toLowerCase().includes(value.toLowerCase()) ||
      item.childData?.some((itemC: any) =>
        itemC.title.toLowerCase().includes(value.toLowerCase()),
      )
    );
  });
};

onBeforeMount(() => {
  window.addEventListener("click", () => {
    isOpen.value = false;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {
    isOpen.value = false;
  });
});
</script>

<style scoped>
.mainWrapper {
  position: relative;
}
.rotated {
  transform: rotate(180deg);
}

.dropdownBody {
  height: 0;
  overflow: hidden;
  /* transition: height 0.3s ease-in-out; */
  position: absolute;
  width: 100%;
  top: 56px;
  z-index: 1;
}
.opened .dropdownBody {
  height: auto;
  border: 1px solid #eff0f1;
  border-top: 0px;
}

.dropdownBody > *:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.searchInput {
  color: #000000;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.searchInput::placeholder {
  color: #b7b7b7;
}

.blurred {
  width: 63px;
  height: 56px;
  background: linear-gradient(
    270deg,
    #f6f7f8 62.64%,
    rgba(246, 247, 248, 0) 98.36%
  );
}

.placeholder {
  cursor: w-resize;
  background-color: transparent !important;
  opacity: 1;
}

.placeholder::-webkit-scrollbar {
  display: none;
}

.dropdownButton {
  border: 1px solid #eff0f1;
}

.is-invalid-input {
  .blurred {
    background: #fee5e2 !important;
  }
  .dropdownButton {
    background: #fee5e2 !important;
  }
}
</style>
